import * as types from './types'
import storage from '@/Plugins/storage'
import globals from '@/Plugins/globals'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_CHECKED](state, data) {
    state.isChecked = false
    // for (let user of state.users) {
    //   if (user.id === data.id) {
    //     user.isChecked = data.isChecked
    //   }
    // }
    // for (let user of state.users) {
    //   if (user.isChecked) {
    //     state.isChecked = true
    //     break
    //   }
    // }
  },
  [types.RESET_RESOURCE](state, data) {
    state.resource = JSON.parse(JSON.stringify(state.defaultResource))
  },
  [types.SET_LIBRARYNAME](state, data) {
    state.libraryName = null
    if (data !== undefined && data !== null) {
      state.libraryName = data
    }
  },
  [types.SET_RESOURCES](state, data) {
    state.resources = []
    if (data !== undefined && data !== null) {
      state.resources = data.data
      let idx = 0
      state.resources.forEach((element) => {
        element.priority = idx
        idx++
      })
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
  },
  [types.SET_RESOURCE](state, data) {
    state.resource = null
    if (data !== undefined && data !== null) {
      let found = state.resources.find((x) => parseInt(x.id) === parseInt(data))
      if (found) {
        state.resource = JSON.parse(JSON.stringify(found))
      }
    }
  },
  [types.SET_RESOURCE_DATA](state, data) {
    switch (data.name) {
      case 'sort': {
        let len = 0
        let idx = 0
        var current = null
        var previous = null
        var next = null
        let change = 0
        len = state.resources.length
        idx = state.resources
          .map((e) => {
            return e.id
          })
          .indexOf(data.value)
        current = state.resources[idx]
        previous = state.resources[(idx + len - 1) % len]
        next = state.resources[(idx + 1) % len]
        change = 0
        if (data.direction === 'up') {
          change = previous.priority
          previous.priority = current.priority
          current.priority = change
          if (current.priority === previous.priority) {
            current.priority++
          }
        } else {
          change = next.priority
          next.priority = current.priority
          current.priority = change
          if (current.priority === next.priority) {
            next.priority++
          }
        }
        state.resources = globals.sortArray(state.resources, 'priority')
        break
      }
      case 'name': {
        state.resource.name = data.value
        break
      }
      case 'url': {
        state.resource.url = data.value
        break
      }
      case 'orgid': {
        state.resource.orgId = data.value
        break
      }
    }
  },
}
